export default __webpack_public_path__ + "static/media/yudy.4a1ff862.png";